import type { CountResponse, Status } from "./common.types";

export const RoleEnum = {
  LIFEGUARD: "LIFEGUARD",
  ADMINISTRATOR: "ADMINISTRATOR",
} as const;

export interface Role {
  id: string;
  name: string;
}

export interface User {
  id: string;
  citizenship_number: string;
  name: string;
  created_at: string;
  status: Status;
  roles: Role[];
}

export interface GetUsersRequest {
  page?: number;
  page_size?: number;
  name?: string;
  citizenship_number?: string;
  status?: string;
  role?: string;
}

export interface CreateUserRequest {
  citizenship_number: string;
  name: string;
  status_id?: number;
  role_id?: number;
}

export interface GetUsersCountRequest {
  name?: string;
  citizenship_number?: string;
  status?: string;
  role?: string;
}

export interface GetUsersCountResponse extends CountResponse {
}